import React, { useEffect, useRef } from 'react';
import {
  useParams
} from 'react-router-dom';

import { mount } from 'redom';

import NativeAppointmentView from './';

function NativeAppointmentViewReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeAppointmentViewReference = useRef(null);

  const { appointmentId } = useParams();

  useEffect(function onLoad() {

    if (nativeAppointmentViewReference.current !== null) {
      return;
    }

    const nativeAppointmentView = new NativeAppointmentView({
      activityId: appointmentId
    });

    nativeAppointmentViewReference.current = nativeAppointmentView;

    mount(wrapperMainReference.current, nativeAppointmentViewReference.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function renderMain() {

    const mainAttributes = {
      className: 'appointment-view-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeAppointmentViewReactWrapper;